/**
|--------------------------------------------------
| Redirect
|--------------------------------------------------
*/
export default function redirect_page(url) {
    window.location.assign(url);
}